import React from "react";
import { Container } from "react-bootstrap";

import NavbarIndex from "../../components/NavbarIndex";
import PricingPlans from "../../components/Login/PricingPlans";
import Footer from "../../components/Footer";
import { useLang } from "../../contexts/LanguageContext";
import { createPricingPlans } from "../../config/pricing";

export default function PricingPage() {
  const { t } = useLang();
  const plans = createPricingPlans(t);

  const handleSelectPlan = (planId) => {
    switch (planId) {
      case "free":
        window.location.href = "/upgrade?plan=free";
        break;
      case "premium":
        window.location.href = "/checkout";
        break;
      default:
        break;
    }
  };

  return (
    <div className="background" style={{ backgroundSize: "cover" }}>
      <Container>
        <NavbarIndex login_button={false} />
        <PricingPlans plans={plans} onSelectPlan={handleSelectPlan} />
      </Container>
      <div className="p-5"></div>
      <Footer />
    </div>
  );
}
